import type { ReactNode } from 'react';

export const symbol_bedtime_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M772-207q-9.6 9-22.8 9-13.2 0-22.29-9.09Q717-217 717-229.83q0-12.84 10-22.17 25-23 42.5-45t28.5-45q-94-7-175.5-43T480-482q-60-60-95.5-140.5T341-797q-25 14-48 31.5T248-726q-8.8 9-22.4 9-13.6 0-22.6-9-9-9-9-22t9-23q29-32 67-56t83-40q20-7 37.5 5.35Q408-849.29 407-829q-3 88 27 167t89 138q60 60 139 91t164 28q21.62-1 34.31 16.5Q873-371 866-350q-13 40-36.5 76T772-207ZM737-26l-90-88q-38 17-78.5 25.5T484-80q-84 0-157.5-32t-128-86.5Q144-253 112-326.5T80-484q0-44 8.5-84.5T114-647l-87-87q-9-9.13-9-22.07Q18-769 27.1-778q9.11-9 22-9 12.9 0 21.9 9L779-68q9 9 9 21t-9 21q-9 9-21 9t-21-9ZM484-140q29.83 0 58.92-5.5Q572-151 599-162L162-599q-11 27-16.5 56t-5.5 59q0 143.33 100.33 243.67Q340.67-140 484-140ZM380-381Zm88-88Z"
		/>
	</svg>
);
